import React from 'react'
import { Badge } from './components/ui/badge'
import { CircleDotIcon, FileCheck2Icon, FileCheckIcon, FileIcon, FileSearch2Icon, FileSpreadsheetIcon, LightbulbIcon, MicIcon, MonitorPlayIcon, XIcon } from 'lucide-react'
import { Button } from './components/ui/button'
import clsx from 'clsx'
import { Separator } from '@radix-ui/react-dropdown-menu'
import { Card } from './components/ui/card'

export default function Guide({ children, step }) {
    const isOpenLS = localStorage.getItem('guide')
    const [isOpen, setIsOpen] = React.useState(isOpenLS ? JSON.parse(isOpenLS) : false)

    React.useEffect(() => {
        localStorage.setItem('guide', JSON.stringify(isOpen))
    }, [isOpen])

    return <div className='relative relative w-full'>
        <Button onClick={() => setIsOpen(!isOpen)} size={'sm'} className={clsx('absolute top-2 right-6 border-yellow-400', step === 'select_mandate' && 'top-0 right-0')} variant={isOpen ? "outline" : "outline"}>
            {isOpen && <XIcon className='w-4 h-4' strokeWidth={1} />}
            {!isOpen && <LightbulbIcon className='w-4 h-4' strokeWidth={1} />}
            Aide
        </Button>

        {isOpen && <div className={clsx('p-4 pb-0', step === 'select_mandate' && 'px-0')}><Card className={'flex flex-col p-4 pt-3 border-yellow-400'}>
            <div className='flex items-start gap-2'>
                {step === 'mandate' && <GuideStep title={"Mandat"} icon={<FileSpreadsheetIcon className='w-4 h-4' strokeWidth={1} />} description={`Corrigez les informations du mandat extraites automatiquement par l’IA.\n Vérifiez et ajustez les champs si nécessaire pour garantir l'exactitude des données.`}>
                    <div className='flex items-center gap-2 text-sm'>
                        <Badge>Le mandat original</Badge> <span className='italic'>à gauche</span>
                    </div>
                    <div className='flex items-center gap-2 text-sm'>
                        <Badge>Le formulaire rempli par l’IA</Badge> <span className='italic'>à droite</span>
                    </div>
                </GuideStep>}

                {step === 'transcription' && <GuideStep title={"Transcription"} icon={<MicIcon className='w-4 h-4' strokeWidth={1} />} description={`Relisez, comparez avec l’audio et ajustez le texte si nécessaire pour garantir la fidélité de la transcription.`}>
                    <div className='flex items-center gap-2 text-sm'>
                        <Badge>Le lecteur audio</Badge> <span className='italic'>en haut pour écouter la dictée</span>
                    </div>
                    <div className='flex items-center gap-2 text-sm'>
                        <Badge>La transcription générée par l’IA</Badge> <span className='italic'>à gauche</span>
                    </div>
                </GuideStep>}

                {step === 'validation' && <GuideStep title={"Rapport"} icon={<FileCheckIcon className='w-4 h-4' strokeWidth={1} />} description={`Vérifiez la mise en page et le contenu du rapport généré.`}>
                    <div className='flex items-center gap-2 text-sm'>
                        <Badge>Le rapport généré</Badge> <span className='italic'>à gauche</span>
                    </div>
                </GuideStep>}

                {step === 'select_mandate' && <GuideStep title={"Identifier le mandat"} icon={<FileSearch2Icon className='w-4 h-4' strokeWidth={1} />} description={`Nous n’avons pas pu identifier automatiquement le mandat parmi les documents.\nVeuillez sélectionner manuellement le bon document pour continuer.`} video={false}>
                    <div className='flex items-center gap-2 text-sm' />
                </GuideStep>}
            </div>
        </Card></div >}
    </div >
}

function GuideStep({ title, description, icon, children, video = true }) {
    return <div className='flex flex-col gap-3 w-full'>
        <div className='flex items-center gap-2 font-semibold'>
            {icon}
            {title}
        </div>
        <div className='flex gap-2 flex-col'>
            {children}
        </div>

        <span className='flex text-sm text-muted-foreground whitespace-pre-line'>
            {description}
        </span>

        {video && <Button className='ml-auto' variant={"ghost"}><MonitorPlayIcon /> Guide vidéo</Button>}
    </div>
}